@if (display(); as d) {
  <div class="call-end-indicator" role="status">
    <glxy-badge [color]="d.color">{{ d.labelKey | translate }}</glxy-badge>
  </div>
}
